// Lib Imports
import React, { useContext } from 'react';
import { Box, Heading, Layer, ResponsiveContext } from 'grommet';

// Core Imports
import Divider from 'granite-admin/core/components/Divider';
import CloseIcon from '../../../common/assets/CloseIcon';
import { ConfigContext } from '../ConfigProvider';
import PropTypes from 'prop-types';
const Split = ({
  setShow,
  upperPane,
  bottomPane,
  heading
}) => {
  const config = useContext(ConfigContext);
  const size = useContext(ResponsiveContext);
  // const { DNA_SLIDER_WIDTH = '480px' } = useContext(ThemeContext);

  return /*#__PURE__*/React.createElement(Layer, {
    full: "vertical",
    position: "right",
    onEsc: () => setShow(false),
    onClickOutside: () => setShow(false)
  }, /*#__PURE__*/React.createElement(Box
  // animation={{ type: 'slideLeft', duration: 500 }}
  , {
    width: size !== 'small' ? `${config.sliderWidth}` : '100%',
    flex: "grow",
    background: "white",
    elevation: "medium",
    pad: {
      horizontal: 'small',
      vertical: 'medium'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "row"
  }, /*#__PURE__*/React.createElement(Heading, {
    level: 3,
    size: "small",
    margin: "none"
  }, heading), /*#__PURE__*/React.createElement(Box, {
    width: "25px",
    height: "25px",
    onClick: () => setShow(false),
    background: "transparent",
    justify: "center",
    align: "center",
    focusIndicator: false,
    style: {
      position: 'absolute',
      left: '-12px',
      top: '0px',
      overflow: 'hidden',
      borderRadius: '50%'
    }
  }, /*#__PURE__*/React.createElement(CloseIcon, null))), /*#__PURE__*/React.createElement(Divider, {
    color: "brand",
    margin: {
      bottom: 'xsmall',
      top: 'xsmall'
    }
  }), /*#__PURE__*/React.createElement(Box, {
    flex: "grow",
    gap: "small",
    margin: {
      vertical: 'small'
    },
    overflow: {
      vertical: 'auto',
      horizontal: 'hidden'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    flex: "grow",
    basis: "0"
  }, upperPane), /*#__PURE__*/React.createElement(Box, {
    basis: "0",
    flex: "grow",
    overflow: {
      vertical: 'auto'
    },
    pad: {
      horizontal: 'xxsmall'
    }
  }, bottomPane))));
};
Split.propTypes = {
  setShow: PropTypes.func,
  upperPane: PropTypes.any,
  bottomPane: PropTypes.any,
  heading: PropTypes.string
};
export default Split;